import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
    getWarehouseItemTransferList as getWarehouseItemTransferListApi,
    getWarehouseItemTransfer as getWarehouseItemTransferApi,
    addNewWarehouseItemTransfer as addNewWarehouseItemTransferApi,
    updateWarehouseItemTransfer as updateWarehouseItemTransferApi,
    deleteWarehouseItemTransfer as deleteWarehouseItemTransferApi,
    transferWarehouseItemTransfer as transferWarehouseItemTransferApi,
    warehouseItemTransferReception as warehouseItemTransferReceptionApi,
    getWarehouseItemTransferListQuery as getWarehouseItemTransferListQueryApi
} from '../../helpers/warehouse/backend_helper';

export const getWarehouseItemTransferList = createAsyncThunk('warehouse_item_transfer/getWarehouseItemTransferList', async (params) => {
    try {
        const response = getWarehouseItemTransferListApi(params);
        return response;
    } catch (error) {
        throw new Error(error);
    }
});

export const getWarehouseItemTransferListQuery = createAsyncThunk('warehouse_item_transfer/getWarehouseItemTransferListQuery', async (params) => {
    try {
        const response = getWarehouseItemTransferListQueryApi(params);
        return response;
    } catch (error) {
        throw new Error(error);
    }
});

export const getWarehouseItemTransfer = createAsyncThunk('warehouse_item_transfer/getWarehouseItemTransfer', async warehouse_item_id => {
    try {
        const response = getWarehouseItemTransferApi(warehouse_item_id);
        return response;
    } catch (error) {
        throw new Error(error);
    }
});

export const addNewWarehouseItemTransfer = createAsyncThunk('warehouse_item_transfer/addNewWarehouseItemTransfer', async warehouse_item => {
    try {
        const response = addNewWarehouseItemTransferApi(warehouse_item);
        toast.success('Transferencia agregada exitosamente.', { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error('Error al agregar la transferencia.', { autoClose: 3000 });
        throw new Error(error);
    }
});

export const updateWarehouseItemTransfer = createAsyncThunk('warehouse_item_transfer/updateWarehouseItemTransfer', async (warehouse_item) => {
    try {
        const response = updateWarehouseItemTransferApi(warehouse_item);
        toast.success('Transferencia actualizado exitosamente', { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error('Error al actualizar la transferencia.', { autoClose: 3000 });
        throw new Error(error);
    }
}
);

export const deleteWarehouseItemTransfer = createAsyncThunk('warehouse_item_transfer/deleteWarehouseItemTransfer', async warehouse_item => {
    try {
        const response = await deleteWarehouseItemTransferApi(warehouse_item);
        toast.success('Transferencia eliminada exitosamente.', { autoClose: 3000 });
        return { warehouse_item, ...response };
    } catch (error) {
        toast.error('Error al eliminar la transferencia.', { autoClose: 3000 });
        throw new Error(error);
    }
});

export const transferWarehouseItemTransfer = createAsyncThunk('warehouse_item_transfer/transferWarehouseItemTransfer', async (warehouse_item) => {
    try {
        const response = await transferWarehouseItemTransferApi(warehouse_item);
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
});

export const warehouseItemTransferReception = createAsyncThunk('warehouse_item_transfer/warehouseItemTransferReception', async warehouse_item => {
    try {
        const response = warehouseItemTransferReceptionApi(warehouse_item);
        toast.success('Items recepcionados exitosamente.', { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error('Error al recepcionar.', { autoClose: 3000 });
        throw new Error(error);
    }
});